export class StoreExport {
    
	storeNumber: string;
	storeName: string;
	dcNumber: number;
    storeLicenseNumber: string;
    //storeAddress: string;
	civicNumber: string;
	suiteNumber: string;
	streetName: string;
	streetType: string;
	streetDirection: string;
	houseNumber: string;
	city: string;
	provinceCode: string;
	postalCode: string;
	storeStatus: string;	
	banner:string;
	sdmStoreNumber:string;
	notes: string;
	lastUpdatedTime: Date;
	
}
